import "./LeftDash.scss";
import orders from "../../assets/images/upload.jpg";

const LeftDash = () => {
  return (
    <div className="left-dash">
      <h2 className="left-dash__title">Upload and Edit Pictures</h2>
      <img src={orders} alt={"baking"} className="left-dash__image" />
    </div>
  );
};

export default LeftDash;
